import React from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from "history";

import { Home } from './features/Main/Home';
import { Programme } from './features/Main/Programme';
import { TheOBSExperiences } from './features/Main/TheOBSExperiences';
import { Activities } from './features/Main/Activities';
import { Safety } from './features/Main/Safety';
import { FAQs } from './features/Main/FAQs/view';
import { NationalOutdoorAdventureMasterPlan } from './features/Main/NationalOutdoorAdventureMasterPlan';
import { Guidelines } from './features/Main/Guidelines';
import { GuidelinesForParents } from './features/Main/GuidelinesForParents';
import { Registration } from './features/Main/Registration';
import { SiteSearch } from './features/Main/SiteSearch';
//import { Structure } from './features/Main/structure';

import { Header } from './Components/Header';
import { Footer } from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import BackToTop from './Components/BackToTop';

export default class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      pageMenu: ""
    };
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const history = createBrowserHistory();
    return (
      <div>
        <Router basename={'/moc'} history={history}>
          <Header />
          <ScrollToTop />
          <BackToTop />
          <div className="main-container">
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/SiteSearch/:keywords" component={SiteSearch} />
              <Route path="/Programme" component={Programme} />
              <Route path="/TheOBSExperience" component={TheOBSExperiences} />
              <Route path="/Activities" component={Activities} />
              <Route path="/Safety" component={Safety} />
              <Route path="/FAQs" component={FAQs} />
              <Route path="/NOAEMasterPlan" component={NationalOutdoorAdventureMasterPlan} />
              {/* <Route path="/Guidelines" component={Guidelines} /> */}
              <Route path="/GuidelinesForParents" component={GuidelinesForParents} />
              <Route path="/Registration" component={Registration} />
            </Switch>
          </div>
          <Footer />
        </Router>
      </div>
    );
  }
}

